module.exports = __webpack_public_path__ + "img/ipad_jp.b5d82eb.jpg";